module.exports = __webpack_public_path__ + "img/stepSecond.eb1559b5.png";